import { render, staticRenderFns } from "./linkStock.vue?vue&type=template&id=65e4f526&"
import script from "./linkStock.vue?vue&type=script&lang=js&"
export * from "./linkStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports